import * as React from "react";

import { Apps28Filled, Apps28Regular } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const SLCApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "SLC" */ "./SLCApp");
    return { default: namedExport.SLCApp };
});

export const SLC: TeamAppConfig = {
    title: "Service List Creator",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "Create and share Lists of Services with ease!",
    team: "ONR",
    publicId: "SKUMAPPINGBRIDGE\\Triage", // SLC's IcM oncall rotation is owned by the SKU Mapping team, confirmed with Angel Arroyo
    owner: "SKUMapBridgeAdmin@microsoft.com",
    role: "*",
    tags: [],
    app: SLCApp,
    path: "/SLC",
    hiddenFromSearch: true
};
